module.exports = __webpack_public_path__ + "img/1-3.45ed3f64.svg";